import axios from 'axios';

const state = () => ({
  list: [],
  testdriveDetail: {},
  cursor: null,
});

const mutations = {
  RESET(s) {
    Object.assign(s, state());
  },
  SET(state, { list, cursor }) {
    state.list = list;
    state.cursor = cursor;
  },
  SET_DETAIL(state, detail) {
    state.testdriveDetail = detail;
  },
  ADD(state, entry) {
    state.list.unshift(entry);
  },
  UPDATE(state, entry) {
    const index = state.list.findIndex(k => k.ID === entry.ID);
    if (index > -1) state.list.splice(index, 1, entry);
  },
  PATCH(state, entry) {
    const index = state.list.findIndex(k => k.ID === entry.ID);
    if (index > -1) Object.assign(state.list[index], entry);
  },
  REMOVE(state, ID) {
    const index = state.list.findIndex(k => k.ID === ID);
    if (index > -1) state.list.splice(index, 1);
  },
};

const actions = {
  reset({ commit }) {
    commit('RESET');
  },
  async getList({ commit, state }, {
    filter,
    search,
    order,
    abortSignal,
  }) {
    let resetList = false;
    if (!state.cursor) resetList = true;

    const { data } = await axios.get('v2/testdrive', {
      params: {
        filter,
        search,
        order,
        cursor: state.cursor,
      },
      signal: abortSignal,
    });

    if (abortSignal?.aborted) return;

    const { list, cursor } = data;

    commit('SET', {
      list: resetList ? list : state.list.concat(list),
      cursor,
    });

    return { cursor: !!cursor, list }; // cursor => isMore?
  },
  async createTestdrive({ commit }, testdrive) {
    const { data } = await axios.post('v2/testdrive', testdrive);
    commit('ADD', data.testdrive);
    return data.testdrive;
  },
  async updateTestdrive({ commit }, testdrive) {
    await axios.put(`v2/testdrive/${testdrive.ID}`, testdrive);
    commit('UPDATE', testdrive);
    commit('SET_DETAIL', testdrive);
  },
  async getTestdrive({ commit }, testdriveId) {
    commit('SET_DETAIL', {});
    const { data } = await axios.get(`v2/testdrive/${testdriveId}`);
    commit('UPDATE', data.data);
    commit('SET_DETAIL', data.data);
    return data.data;
  },
  async removeTestdrive({ commit }, testdriveId) {
    await axios.delete(`v2/testdrive/${testdriveId}`);
    commit('REMOVE', testdriveId);
  },
  async updateTestdriveStatus({ commit, state }, { testdriveId, status }) {
    await axios.patch(`v2/testdrive/${testdriveId}/status`, { status });
    commit('PATCH', { ID: +testdriveId, status });
    if (state.testdriveDetail.ID === testdriveId) {
      commit('SET_DETAIL', { ...state.testdriveDetail, status });
    }
  },
  async checkAvailability(_, { testdriveId, vehicleId, licensePlateId, startDate, endDate }) {
    const { data } = await axios.get('v2/testdrive/availability', {
      params: { testdriveId, vehicleId, licensePlateId, startDate, endDate },
    });
    return data.available;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
